// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paperRoot-2AQ8E";
var _4 = "header-3AQpE";
var _5 = "heading-3Avsn";
var _6 = "fareConditionsContent-1lqSG";
var _7 = "fareConditionsSegmentFareCode-2k0ih";
export { _1 as "__esModule", _2 as "mobile", _3 as "paperRoot", _4 as "header", _5 as "heading", _6 as "fareConditionsContent", _7 as "fareConditionsSegmentFareCode" }
export default { "__esModule": _1, "mobile": _2, "paperRoot": _3, "header": _4, "heading": _5, "fareConditionsContent": _6, "fareConditionsSegmentFareCode": _7 }
